export const blockIconsSearchPodcasts = (
	<span className='material-symbols-outlined'>podcasts</span>
);
